import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from '../sic-tab-panel/sic-tab-panel.css.lit';

/**
 * The SicTabPanel component
 * @element sic-tab-panel
 * @slot - default slot for sic-styled-text.
 * @prop {String} - Title for the tab as seen by users.
 */
@customElement('sic-tab-panel')
export class SicTabPanel extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Title for the tab as seen by users.
   */
  @property({ type: String, attribute: 'tab-title', reflect: true })
  tabTitle: string;

  render(): TemplateResult {
    return html`
      <section class="sic-tab-panel" role="tabpanel" tabindex="-1">
        <slot></slot>
      </section>
    `;
  }
}
